import request from '@/utils/request'

export default {
    getUnallocatedData: async({ dispatch, commit }) => {
        commit('SET_LOAD', true)

        await request({ method: 'get', url: '/clients/unallocated' })
            .then(res => {
                if (res.data) {
                    commit('PROCCESS_DATA', res.data)
                }
            }).finally(() => {
                commit('SET_LOAD', false)
            })
    },

    editFee: async({ dispatch, commit }, { serverId, fee }) => {
        return await request({ method: 'put', url: `/servers/${serverId}/fee`, data: { fee }})
            .then(res => res.status == 204)
            .catch(() => null)
    },

    resetBalance: async({ dispatch, commit }, serverId) => {
        return await request({ method: 'patch', url: `/servers/${serverId}/reset-balance` })
            .then(res => res.status == 204)
            .catch(() => null)
    }
}
